import type { ReactNode } from 'react';
import { useSession } from '../../hooks/useSession';
import { Footer } from '../landing/sections/Footer';
import { Nav } from '../landing/sections/Nav';

export interface LegalLayoutProps {
  title: string;
  effectiveDate: string;
  children: ReactNode;
}

/**
 * Shared chrome for /privacy and /terms — landing-page Nav and Footer wrapped
 * around long-form prose. Uses the same color tokens as the rest of the site
 * so legal pages feel like part of the product, not an afterthought.
 *
 * The body uses a typography scale tuned for reading rather than marketing
 * copy: tighter leading on headings, generous spacing between sections.
 */
export function LegalLayout({ title, effectiveDate, children }: LegalLayoutProps) {
  const { user } = useSession();

  return (
    <div className="bg-background text-foreground min-h-screen">
      <Nav user={user} />
      <main className="mx-auto max-w-[760px] px-6 py-16 lg:px-10 lg:py-24">
        <header className="border-border mb-12 border-b pb-8">
          <h1 className="font-display text-4xl font-bold tracking-tight lg:text-5xl">{title}</h1>
          <p className="text-muted-foreground mt-3 text-sm">
            Effective {effectiveDate}
          </p>
        </header>
        <article className="legal-prose">{children}</article>
      </main>
      <Footer />
    </div>
  );
}
